<template lang="pug">
.tl(ref="rootRef")
  .tl-card(:class="{ 'is-resetting': resetting }" aria-hidden="true")
    .tl-body
      section.tl-pane.tl-lines-pane
        .tl-pane-head
          span.tl-pane-title {{ t('my_lines.title') }}
        .tl-line(v-for="line in lines" :key="line.id" :data-line="line.id" :class="{ 'is-flash': savedLine === line.id }")
          .tl-line-row
            span.tl-flag {{ line.flag }}
            span.tl-line-copy
              span.tl-line-name {{ t(`org.landing.lines.line_${line.id}`) }}
              span.tl-line-meta
                template(v-if="line.shared")
                  Users.tl-meta-icon
                  span {{ t('my_lines.shared_with', { name: 'Acme Studio' }) }}
                  span.tl-meta-count
                    UserCheck.tl-meta-icon
                    span {{ t('my_lines.people_count', { count: line.people }) }}
                template(v-else)
                  LockKeyhole.tl-meta-icon
                  span {{ t('my_lines.private') }}
            span.tl-btn(:class="{ 'is-pressed': pressed === `manage-${line.id}` }")
              Pencil.tl-btn-icon
              span {{ t('my_lines.manage') }}
          p.tl-line-saved(v-if="line.id === 'tokyo'" :class="{ 'is-on': savedLine === 'tokyo' }")
            CheckCircle2.tl-saved-icon
            span {{ t('my_lines.saved') }}
      section.tl-pane.tl-usage-pane
        .tl-pane-head
          span.tl-pane-title
            BarChart3.tl-title-icon
            | {{ t('my_lines.usage_title') }}
          span.tl-select
            span 🇯🇵 {{ t('org.landing.lines.line_tokyo') }}
            ChevronDown.tl-select-icon
        .tl-summary
          div
            p.tl-selected {{ selectedLabel }}
            p.tl-total {{ formatDedicatedBytes(shownTotal) }}
          span.tl-range {{ t('trchart.last24') }}
        .tl-plot(:class="{ 'is-grown': grown }")
          .tl-bar(v-for="bar in plotBars" :key="bar.hour" :style="{ '--h': `${bar.height}%`, '--i': bar.hour }")
            i.tl-seg(v-for="seg in bar.segments" :key="seg.member" :data-member="members[seg.member].email" :style="{ height: `${seg.height}%`, background: members[seg.member].color }")
          p.tl-plot-empty(:class="{ 'is-on': emptyNote }") {{ emptyNote }}
        .tl-axis
          span 00:00
          span 12:00
          span 23:00
        .tl-legend-head(:class="{ 'is-in': grown }")
          span {{ t('my_lines.usage_members') }}
          span.tl-legend-all(:data-state="allState")
            span.tl-check(:class="{ 'is-on': allState !== 'off' }")
              Minus.tl-check-icon(v-if="allState === 'mixed'")
              Check.tl-check-icon(v-else)
            span {{ t('my_lines.usage_all') }}
        .tl-legend
          span.tl-legend-item(v-for="(memberIndex, rank) in usage.legendOrder" :key="memberIndex" :data-member="members[memberIndex].email" :class="{ 'is-in': grown, 'is-on': isSelected(memberIndex) }" :style="{ '--i': rank, '--c': members[memberIndex].color }")
            span.tl-legend-label
              span.tl-legend-check
                Check.tl-legend-tick
              span.tl-legend-email {{ members[memberIndex].email }}
            span.tl-legend-amount {{ formatDedicatedBytes(usage.totals[memberIndex]) }}
            span.tl-legend-track
              i(:style="{ width: `${usage.totals[memberIndex] / usage.total * 100}%` }")
    .tl-dialog(:class="{ 'is-on': dialogOpen }")
      .tl-dialog-panel
        .tl-dialog-head
          span.tl-flag 🇯🇵
          span.tl-line-copy
            span.tl-eyebrow {{ t('my_lines.edit_title') }}
            span.tl-line-name {{ t('org.landing.lines.line_tokyo') }}
        .tl-options
          span.tl-option(data-option="private" :class="{ 'is-selected': !teamSelected }")
            LockKeyhole.tl-option-icon
            span.tl-option-copy
              strong {{ t('my_lines.private') }}
              span {{ t('my_lines.private_option_hint') }}
          span.tl-option(data-option="team" :class="{ 'is-selected': teamSelected, 'is-pressed': pressed === 'team' }")
            Users.tl-option-icon
            span.tl-option-copy
              strong {{ t('my_lines.share') }}
              span {{ t('my_lines.team_option_hint') }}
        .tl-members(v-if="teamSelected")
          .tl-members-head
            span {{ t('my_lines.members') }}
            span.tl-muted {{ t('my_lines.selected', { count: checkedCount }) }}
            span.tl-select-all
              span.tl-check(:class="{ 'is-on': checkedCount === members.length }")
                Check.tl-check-icon
              span {{ t('my_lines.select_all') }}
          .tl-member(v-for="(member, index) in members" :key="member.email" :class="{ 'is-on': checked[index] }")
            span.tl-check(:class="{ 'is-on': checked[index] }")
              Check.tl-check-icon
            span.tl-avatar {{ member.email.slice(0, 2).toUpperCase() }}
            span.tl-member-email {{ member.email }}
            span.tl-muted(v-if="index === OWNER") {{ t('my_lines.owner') }}
        .tl-dialog-foot
          span.tl-btn {{ t('my_lines.cancel') }}
          span.tl-btn.is-primary.tl-save(:class="{ 'is-pressed': pressed === 'save' }") {{ t('my_lines.save') }}
    .tl-cursor(:class="{ 'is-on': cursorVisible, 'is-click': clicking }" :style="cursorStyle")
      svg(viewBox="0 0 24 24" width="22" height="22")
        path(d="M5 3l14 8.5-6.2 1.6L16 20l-2.6 1.2-3.2-6.9L5 19z" fill="#fff" stroke="#111" stroke-width="1.4" stroke-linejoin="round")
  ol.tl-steps(aria-hidden="true")
    li.tl-step(v-for="step in stepOrder" :key="step" :data-step="step" :class="{ 'is-active': currentStep === step, 'is-done': stepDone(step) }")
      i.tl-step-dot
      span {{ t(`org.landing.lines.steps.${step}`) }}
</template>

<script setup lang="ts">
/**
 * Plays the dedicated-line sharing workflow on a loop: share a private line with the team →
 * grant members access → read each member's hourly traffic on the usage chart.
 * Purely presentational; it reuses the real dashboard's my_lines copy and mirrors
 * DedicatedLineEditor and DedicatedUsageChart behaviour (owner always checked, legend
 * sorted by usage, "All members" then one member to filter, unselected series removed).
 */
import { BarChart3, Check, CheckCircle2, ChevronDown, LockKeyhole, Minus, Pencil, UserCheck, Users } from 'lucide-vue-next'
import { formatDedicatedBytes } from '~/utils/dedicatedUsage'
import { linesDemoUsage } from '~/utils/teamsLinesDemo'

const { t } = useI18n()

const stepOrder = ['share', 'assign', 'usage'] as const
type DemoStep = typeof stepOrder[number]

const LOOP_MS = 16000
const OWNER = 0
/** The member the cursor filters the chart to (ben). */
const FILTER_MEMBER = 2

// Ordered by user id, coloured like DedicatedUsageChart: palette[index].
const members = [
  { email: 'owner@acme.com', color: '#A4CE8B' },
  { email: 'alice@acme.com', color: '#F7E49B' },
  { email: 'ben@acme.com', color: '#7EA69B' },
  { email: 'chloe@acme.com', color: '#8CA37E' },
] as const
const usage = linesDemoUsage(members.map(member => member.email))

const makeLines = () => [
  { id: 'tokyo', flag: '🇯🇵', shared: false, people: 1 },
  { id: 'hk', flag: '🇭🇰', shared: true, people: 3 },
  { id: 'sg', flag: '🇸🇬', shared: false, people: 1 },
]

const rootRef = ref<HTMLElement>()

const lines = ref(makeLines())
const dialogOpen = ref(false)
const teamSelected = ref(false)
const checked = ref(members.map(() => false))
const savedLine = ref('')
const grown = ref(false)
/** Same model as DedicatedUsageChart: null means every member. */
const selected = ref<number[] | null>(null)
const shownTotal = ref(0)
const pressed = ref('')
const currentStep = ref<DemoStep | null>(null)
const resetting = ref(false)
const cursorVisible = ref(false)
const clicking = ref(false)
const cursorX = ref(0)
const cursorY = ref(0)

const isSelected = (index: number) => selected.value === null || selected.value.includes(index)
const checkedCount = computed(() => checked.value.filter(Boolean).length)
const allState = computed(() => selected.value === null ? 'on' : selected.value.length ? 'mixed' : 'off')
const selectedTotal = computed(() => usage.totals.reduce((sum, value, index) => sum + (isSelected(index) ? value : 0), 0))
const selectedLabel = computed(() => {
  if (selected.value === null) return t('my_lines.usage_all')
  if (selected.value.length === 1) return members[selected.value[0]!]!.email
  return t('my_lines.usage_selected', { count: selected.value.length })
})
const emptyNote = computed(() => {
  if (!grown.value) return t('my_lines.usage_empty')
  return selectedTotal.value ? '' : t('my_lines.usage_select_members')
})
/** Bars hold only the selected series and rescale to their own peak, like the real chart re-renders. */
const plotBars = computed(() => {
  const visible = usage.bars.map(bar => bar.values.reduce((sum, value, index) => sum + (isSelected(index) ? value : 0), 0))
  const peak = Math.max(...visible)
  return usage.bars.map((bar, hour) => ({
    hour,
    height: peak ? visible[hour]! / peak * 100 : 0,
    segments: bar.values.map((value, member) => ({ member, height: isSelected(member) && visible[hour] ? value / visible[hour]! * 100 : 0 })),
  }))
})
const cursorStyle = computed(() => ({ '--x': `${cursorX.value}px`, '--y': `${cursorY.value}px` }))

const stepDone = (step: DemoStep) => {
  if (!currentStep.value) return false
  return stepOrder.indexOf(step) < stepOrder.indexOf(currentStep.value)
}

const { revealed, reducedMotion } = useRevealOnce(rootRef, { threshold: 0.3 })
const inView = ref(false)

let timers: ReturnType<typeof setTimeout>[] = []
let totalFrame: number | null = null
let playing = false
let started = false
let viewObserver: IntersectionObserver | null = null

const at = (ms: number, run: () => void) => {
  timers.push(setTimeout(run, ms))
}

const find = (selector: string) => rootRef.value?.querySelector<HTMLElement>(selector)

function moveCursorTo(target?: HTMLElement | null) {
  const root = rootRef.value
  if (!root || !target) return
  const rootRect = root.getBoundingClientRect()
  const rect = target.getBoundingClientRect()
  cursorX.value = rect.left - rootRect.left + Math.min(rect.width * 0.55, 60)
  cursorY.value = rect.top - rootRect.top + rect.height * 0.6
  cursorVisible.value = true
}

function click(target: string) {
  clicking.value = true
  pressed.value = target
  at(170, () => {
    clicking.value = false
  })
  at(260, () => {
    pressed.value = ''
  })
}

function tweenTotal(durationMs: number) {
  if (totalFrame) cancelAnimationFrame(totalFrame)
  const from = shownTotal.value
  const to = selectedTotal.value
  const startedAt = performance.now()
  const frame = (now: number) => {
    const progress = Math.min(1, (now - startedAt) / durationMs)
    shownTotal.value = Math.round(from + (to - from) * (1 - (1 - progress) ** 3))
    totalFrame = progress < 1 ? requestAnimationFrame(frame) : null
  }
  totalFrame = requestAnimationFrame(frame)
  // Background tabs stop animation frames; pin the final value so the state machine stays consistent.
  at(durationMs + 50, () => {
    if (totalFrame) cancelAnimationFrame(totalFrame)
    totalFrame = null
    shownTotal.value = to
  })
}

function select(next: number[] | null, durationMs: number) {
  click('')
  selected.value = next
  tweenTotal(durationMs)
}

function shareTokyo() {
  lines.value = lines.value.map(line => line.id === 'tokyo' ? { ...line, shared: true, people: members.length } : line)
}

function resetState() {
  lines.value = makeLines()
  dialogOpen.value = false
  teamSelected.value = false
  checked.value = members.map(() => false)
  savedLine.value = ''
  grown.value = false
  selected.value = null
  shownTotal.value = 0
  pressed.value = ''
  currentStep.value = null
  clicking.value = false
  cursorVisible.value = false
  if (totalFrame) {
    cancelAnimationFrame(totalFrame)
    totalFrame = null
  }
}

function clearTimers() {
  timers.forEach(timer => clearTimeout(timer))
  timers = []
}

function showFinalState() {
  shareTokyo()
  grown.value = true
  shownTotal.value = usage.total
  currentStep.value = 'usage'
}

function play() {
  clearTimers()
  // Reset while the body is faded out (transitions are off then), then fade back in.
  if (started) resetting.value = true
  started = true
  resetState()
  playing = true
  at(60, () => {
    resetting.value = false
  })

  at(300, () => moveCursorTo(find('.tl-line[data-line="tokyo"] .tl-btn')))
  at(950, () => {
    click('manage-tokyo')
    dialogOpen.value = true
    currentStep.value = 'share'
  })
  at(1500, () => moveCursorTo(find('.tl-option[data-option="team"]')))
  at(2100, () => {
    click('team')
    teamSelected.value = true
    checked.value = members.map((_, index) => index === OWNER)
  })
  at(2700, () => moveCursorTo(find('.tl-select-all')))
  at(3300, () => {
    click('')
    currentStep.value = 'assign'
  })
  members.forEach((_, index) => index !== OWNER && at(3300 + index * 120, () => {
    checked.value = checked.value.map((value, i) => value || i === index)
  }))
  at(4000, () => moveCursorTo(find('.tl-save')))
  at(4600, () => click('save'))
  at(4800, () => {
    dialogOpen.value = false
    shareTokyo()
    savedLine.value = 'tokyo'
  })
  at(5300, () => {
    currentStep.value = 'usage'
    grown.value = true
    tweenTotal(1200)
  })
  at(7600, () => moveCursorTo(find('.tl-legend-all')))
  at(8200, () => select([], 500))
  at(8800, () => moveCursorTo(find(`.tl-legend-item[data-member="${members[FILTER_MEMBER].email}"]`)))
  at(9400, () => select([FILTER_MEMBER], 700))
  at(11600, () => moveCursorTo(find('.tl-legend-all')))
  at(12200, () => select(null, 700))
  at(13000, () => {
    cursorVisible.value = false
    savedLine.value = ''
  })
  at(LOOP_MS - 500, () => {
    resetting.value = true
  })
  at(LOOP_MS, play)
}

function stop() {
  clearTimers()
  playing = false
}

/** Play only while the demo is revealed, on screen and in a visible tab; restart from the top on return. */
function syncPlayback() {
  if (!revealed.value || reducedMotion.value) return
  const shouldPlay = inView.value && !document.hidden
  if (shouldPlay && !playing) play()
  else if (!shouldPlay && playing) stop()
}

watch(revealed, (isRevealed) => {
  if (!isRevealed) return
  if (reducedMotion.value) {
    showFinalState()
    return
  }
  syncPlayback()
})

onMounted(() => {
  document.addEventListener('visibilitychange', syncPlayback)
  if (!rootRef.value) return
  viewObserver = new IntersectionObserver((entries) => {
    inView.value = entries.some(entry => entry.isIntersecting)
    syncPlayback()
  })
  viewObserver.observe(rootRef.value)
})

onBeforeUnmount(() => {
  stop()
  viewObserver?.disconnect()
  if (totalFrame) cancelAnimationFrame(totalFrame)
  document.removeEventListener('visibilitychange', syncPlayback)
})
</script>

<style lang="postcss" scoped>
.tl {
  --tl-bg: var(--tm-surface, #0b0e0a);
  --tl-bg-2: var(--tm-surface-2, #161a15);
  --tl-text: var(--tm-text, #f5f7f1);
  --tl-copy: var(--tm-copy, #969f92);
  --tl-faint: var(--tm-faint, #626a5e);
  --tl-line: var(--tm-line, rgba(255, 255, 255, 0.08));
  --tl-line-strong: var(--tm-line-strong, rgba(255, 255, 255, 0.16));
  --tl-green: var(--tm-green, #7ed321);
  --tl-green-soft: var(--tm-green-soft, rgba(126, 211, 33, 0.16));
  --tl-on-green: var(--tm-on-green, #071006);
  --tl-ease: cubic-bezier(0.16, 1, 0.3, 1);

  position: relative;
  width: 100%;
  container-type: inline-size;
  font-size: 0.78rem;
  color: var(--tl-text);
}

.tl-card {
  position: relative;
  overflow: hidden;
  border: 1px solid var(--tl-line);
  border-radius: 14px;
  background: var(--tl-bg);
  box-shadow:
    0 30px 80px -30px rgba(0, 0, 0, 0.6),
    0 0 0 1px rgba(126, 211, 33, 0.04);
}

.tl-body {
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  transition: opacity 0.45s var(--tl-ease);
}

.tl-card.is-resetting .tl-body {
  opacity: 0;
}

.tl-pane {
  min-width: 0;
  padding: 1rem;
}

.tl-lines-pane {
  border-right: 1px solid var(--tl-line);
}

.tl-pane-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  min-height: 1.9rem;
  margin-bottom: 0.85rem;
}

.tl-pane-title {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.86rem;
  font-weight: 700;
  white-space: nowrap;
}

.tl-title-icon {
  width: 1rem;
  height: 1rem;
  color: var(--tl-green);
}

/* ---------- lines ---------- */

.tl-line {
  padding: 0.85rem 0.75rem;
  border: 1px solid var(--tl-line);
  border-radius: 10px;
  transition:
    border-color 0.4s var(--tl-ease),
    background-color 0.4s var(--tl-ease);
}

.tl-line + .tl-line {
  margin-top: 0.5rem;
}

.tl-line.is-flash {
  border-color: var(--tl-green);
  background: var(--tl-green-soft);
}

.tl-line-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.tl-line-saved {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  max-height: 0;
  margin: 0 0 0 2.85rem;
  overflow: hidden;
  color: var(--tl-green);
  font-size: 0.7rem;
  font-weight: 600;
  opacity: 0;
  transition:
    max-height 0.35s var(--tl-ease),
    margin 0.35s var(--tl-ease),
    opacity 0.35s var(--tl-ease);
}

.tl-line-saved.is-on {
  max-height: 3rem;
  margin-top: 0.5rem;
  opacity: 1;
}

.tl-saved-icon {
  flex: none;
  width: 0.85rem;
  height: 0.85rem;
}

.tl-flag {
  display: grid;
  place-items: center;
  flex: none;
  width: 2.1rem;
  height: 2.1rem;
  border: 1px solid var(--tl-line);
  border-radius: 8px;
  background: var(--tl-bg-2);
  font-size: 1.15rem;
  line-height: 1;
}

.tl-line-copy {
  display: grid;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
}

.tl-line-name {
  font-size: 0.84rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tl-line-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.15rem 0.3rem;
  min-width: 0;
  color: var(--tl-copy);
  font-size: 0.7rem;
}

/* Own line with its own icon, so it never wraps mid-phrase. */
.tl-meta-count {
  display: flex;
  align-items: center;
  flex-basis: 100%;
  gap: 0.3rem;
}

.tl-meta-icon {
  flex: none;
  width: 0.8rem;
  height: 0.8rem;
}

.tl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  gap: 0.35rem;
  height: 1.9rem;
  padding: 0 0.7rem;
  border: 1px solid var(--tl-line-strong);
  border-radius: 8px;
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  transition:
    transform 0.18s var(--tl-ease),
    background-color 0.25s var(--tl-ease),
    border-color 0.25s var(--tl-ease);
}

.tl-btn-icon {
  width: 0.8rem;
  height: 0.8rem;
}

.tl-btn.is-primary {
  border-color: transparent;
  background: var(--tl-green);
  color: var(--tl-on-green);
}

.tl-btn.is-pressed,
.tl-option.is-pressed {
  transform: scale(0.95);
}

.tl-btn:not(.is-primary).is-pressed {
  background: var(--tl-green-soft);
  border-color: var(--tl-green);
}

/* ---------- usage ---------- */

.tl-select {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
  height: 1.9rem;
  padding: 0 0.6rem;
  border: 1px solid var(--tl-line-strong);
  border-radius: 8px;
  color: var(--tl-copy);
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
}

.tl-select > span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.tl-select-icon {
  flex: none;
  width: 0.8rem;
  height: 0.8rem;
}

.tl-summary {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
}

.tl-selected {
  color: var(--tl-copy);
  font-size: 0.7rem;
}

.tl-total {
  margin-top: 0.15rem;
  font-size: 1.45rem;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}

.tl-range {
  flex: none;
  color: var(--tl-faint);
  font-size: 0.66rem;
  font-weight: 700;
}

.tl-plot {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 7.5rem;
  margin-top: 0.85rem;
  padding-bottom: 1px;
  border-bottom: 1px solid var(--tl-line);
}

.tl-bar {
  display: flex;
  flex: 1;
  flex-direction: column-reverse;
  min-width: 0;
  height: var(--h);
  overflow: hidden;
  border-radius: 3px 3px 1px 1px;
  transform: scaleY(0);
  transform-origin: bottom;
  transition:
    transform 0.7s var(--tl-ease) calc(var(--i) * 28ms),
    height 0.55s var(--tl-ease);
}

.tl-plot.is-grown .tl-bar {
  transform: scaleY(1);
}

.tl-seg {
  display: block;
  flex: none;
  width: 100%;
  transition: height 0.55s var(--tl-ease);
}

/* Restarting the loop happens while the body is faded out; snap back instead of animating. */
.tl-card.is-resetting :is(.tl-bar, .tl-seg, .tl-legend-head, .tl-legend-item, .tl-line, .tl-line-saved, .tl-plot-empty) {
  transition: none;
}

.tl-plot-empty {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  margin: 0;
  color: var(--tl-faint);
  opacity: 0;
  transition: opacity 0.3s var(--tl-ease);
}

.tl-plot-empty.is-on {
  opacity: 1;
}

.tl-axis {
  display: flex;
  justify-content: space-between;
  margin-top: 0.35rem;
  color: var(--tl-faint);
  font-size: 0.62rem;
  font-variant-numeric: tabular-nums;
}

.tl-legend-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.75rem;
  color: var(--tl-faint);
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0;
  transition: opacity 0.45s var(--tl-ease) 0.4s;
}

.tl-legend-head.is-in {
  opacity: 1;
}

.tl-legend-all {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--tl-text);
  letter-spacing: normal;
  text-transform: none;
}

.tl-legend {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.35rem;
  margin-top: 0.4rem;
}

.tl-legend-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.35rem 0.6rem;
  padding: 0.5rem 0.55rem;
  border: 1px solid transparent;
  border-radius: 8px;
  opacity: 0;
  transform: translate3d(0, 0.4rem, 0);
  transition:
    opacity 0.45s var(--tl-ease) calc(0.5s + var(--i) * 90ms),
    transform 0.45s var(--tl-ease) calc(0.5s + var(--i) * 90ms),
    border-color 0.3s var(--tl-ease),
    background-color 0.3s var(--tl-ease);
}

.tl-legend-item.is-in {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

.tl-legend-item.is-on {
  border-color: var(--tl-line-strong);
  background: var(--tl-bg-2);
}

.tl-legend-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
}

.tl-legend-check {
  display: inline-grid;
  place-items: center;
  flex: none;
  width: 0.8rem;
  height: 0.8rem;
  border: 1px solid var(--c);
  border-radius: 3px;
  color: #213021;
  transition: background-color 0.25s var(--tl-ease);
}

.tl-legend-item.is-on .tl-legend-check {
  background: var(--c);
}

.tl-legend-tick {
  width: 0.6rem;
  height: 0.6rem;
  opacity: 0;
}

.tl-legend-item.is-on .tl-legend-tick {
  opacity: 1;
}

.tl-legend-email {
  overflow: hidden;
  font-size: 0.7rem;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tl-legend-amount {
  font-size: 0.7rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.tl-legend-track {
  grid-column: 1 / -1;
  height: 3px;
  overflow: hidden;
  border-radius: 2px;
  background: var(--tl-line);
}

.tl-legend-track > i {
  display: block;
  height: 100%;
  background: var(--c);
}

/* ---------- access dialog ---------- */

.tl-dialog {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: grid;
  place-items: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s var(--tl-ease);
}

.tl-dialog.is-on {
  opacity: 1;
}

.tl-dialog-panel {
  width: min(100%, 25rem);
  overflow: hidden;
  border: 1px solid var(--tl-line-strong);
  border-radius: 12px;
  background: var(--tl-bg);
  box-shadow: 0 24px 60px -20px rgba(0, 0, 0, 0.7);
  transform: translate3d(0, 0.8rem, 0) scale(0.97);
  transition: transform 0.4s var(--tl-ease);
}

.tl-dialog.is-on .tl-dialog-panel {
  transform: translate3d(0, 0, 0) scale(1);
}

.tl-dialog-head {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 0.9rem;
  border-bottom: 1px solid var(--tl-line);
}

.tl-eyebrow {
  color: var(--tl-faint);
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.tl-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
  padding: 0.75rem 0.9rem 0;
}

.tl-option {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  min-width: 0;
  padding: 0.6rem;
  border: 1px solid var(--tl-line-strong);
  border-radius: 8px;
  transition:
    transform 0.18s var(--tl-ease),
    border-color 0.25s var(--tl-ease),
    background-color 0.25s var(--tl-ease);
}

.tl-option.is-selected {
  border-color: var(--tl-green);
  background: var(--tl-green-soft);
}

.tl-option-icon {
  flex: none;
  width: 0.9rem;
  height: 0.9rem;
  margin-top: 0.05rem;
  color: var(--tl-copy);
}

.tl-option.is-selected .tl-option-icon {
  color: var(--tl-green);
}

.tl-option-copy {
  display: grid;
  gap: 0.2rem;
  min-width: 0;
  font-size: 0.72rem;
}

.tl-option-copy > span {
  color: var(--tl-copy);
  font-size: 0.64rem;
  line-height: 1.35;
}

.tl-members {
  padding: 0.7rem 0.9rem 0;
  animation: tl-fade-in 0.35s var(--tl-ease);
}

@keyframes tl-fade-in {
  from {
    opacity: 0;
    transform: translate3d(0, 0.3rem, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.tl-members-head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid var(--tl-line);
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
}

.tl-select-all {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-left: auto;
}

.tl-muted {
  color: var(--tl-copy);
  font-weight: 500;
}

.tl-member {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 1.95rem;
  font-size: 0.7rem;
}

.tl-member + .tl-member {
  border-top: 1px solid var(--tl-line);
}

.tl-avatar {
  display: grid;
  place-items: center;
  flex: none;
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 50%;
  background: var(--tl-bg-2);
  color: var(--tl-copy);
  font-size: 0.55rem;
  font-weight: 700;
  transition: background-color 0.25s var(--tl-ease);
}

.tl-member.is-on .tl-avatar {
  background: var(--tl-green-soft);
  color: var(--tl-text);
}

.tl-member-email {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tl-check {
  display: inline-grid;
  place-items: center;
  flex: none;
  width: 0.95rem;
  height: 0.95rem;
  border: 1px solid var(--tl-line-strong);
  border-radius: 4px;
  color: var(--tl-on-green);
  transition:
    background-color 0.2s var(--tl-ease),
    border-color 0.2s var(--tl-ease);
}

.tl-check-icon {
  width: 0.65rem;
  height: 0.65rem;
  opacity: 0;
  transform: scale(0.5);
  transition:
    opacity 0.2s var(--tl-ease),
    transform 0.2s var(--tl-ease);
}

.tl-check.is-on {
  border-color: var(--tl-green);
  background: var(--tl-green);
}

.tl-check.is-on .tl-check-icon {
  opacity: 1;
  transform: scale(1);
}

.tl-dialog-foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.7rem 0.9rem;
  border-top: 1px solid var(--tl-line);
}

/* ---------- cursor ---------- */

.tl-cursor {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.45));
  opacity: 0;
  transform: translate3d(var(--x), var(--y), 0) scale(1);
  transform-origin: 5px 3px;
  pointer-events: none;
  transition:
    transform 0.7s var(--tl-ease),
    opacity 0.3s var(--tl-ease);
}

.tl-cursor.is-on {
  opacity: 1;
}

.tl-cursor.is-click {
  transform: translate3d(var(--x), var(--y), 0) scale(0.82);
  transition-duration: 0.12s;
}

/* ---------- steps legend ---------- */

.tl-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  margin: 1rem 0 0;
  padding: 0;
  list-style: none;
}

.tl-step {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  color: var(--tl-faint);
  font-size: 0.72rem;
  font-weight: 700;
  transition:
    color 0.3s var(--tl-ease),
    background-color 0.3s var(--tl-ease);
}

.tl-step + .tl-step::before {
  content: '';
  width: 1.2rem;
  height: 1px;
  margin-right: 0.35rem;
  margin-left: -0.55rem;
  background: var(--tl-line-strong);
}

.tl-step-dot {
  width: 0.5rem;
  height: 0.5rem;
  border: 1px solid var(--tl-line-strong);
  border-radius: 999px;
  transition:
    background-color 0.3s var(--tl-ease),
    border-color 0.3s var(--tl-ease),
    box-shadow 0.3s var(--tl-ease);
}

.tl-step.is-active {
  color: var(--tl-text);
  background: var(--tl-green-soft);
}

.tl-step.is-active .tl-step-dot,
.tl-step.is-done .tl-step-dot {
  border-color: var(--tl-green);
  background: var(--tl-green);
}

.tl-step.is-active .tl-step-dot {
  box-shadow: 0 0 0 0.25rem rgba(126, 211, 33, 0.2);
}

.tl-step.is-done {
  color: var(--tl-copy);
}

@container (max-width: 720px) {
  .tl-body {
    grid-template-columns: minmax(0, 1fr);
  }

  .tl-lines-pane {
    border-right: 0;
    border-bottom: 1px solid var(--tl-line);
  }
}

@container (max-width: 420px) {
  .tl-legend {
    grid-template-columns: minmax(0, 1fr);
  }

  .tl-btn-icon {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .tl-body,
  .tl-bar,
  .tl-seg,
  .tl-legend-head,
  .tl-legend-item,
  .tl-dialog,
  .tl-dialog-panel,
  .tl-line-saved,
  .tl-cursor,
  .tl-check,
  .tl-check-icon {
    transition: none;
  }

  .tl-members {
    animation: none;
  }

  .tl-cursor {
    display: none;
  }
}
</style>
